import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src4125225622/src/dashboard/apps/website/layouts/default.vue").then(m => m.default || m))
}